export default __webpack_public_path__ + "static/media/surge.448e8243.png";